import { DefaultRootState } from 'react-redux';

import { Nullable } from 'types';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

export type VacancyId = Nullable<number>;
type VacancyName = Nullable<string>;
type Link = Nullable<string>;

interface VacancyInfo {
    vacancyId: VacancyId;
    vacancyName?: VacancyName;
}

// ----------------------- actions -------------------------------------
const SET_MAIN_MENU_VACANCY = 'SET_MAIN_MENU_VACANCY';
const SET_MAIN_MENU_LINK = 'SET_MAIN_MENU_LINK';
const RESET_MAIN_MENU_FORM_DATA = 'RESET_MAIN_MENU_FORM_DATA';
const RESET_MAIN_MENU_ALL_DATA = 'RESET_MAIN_MENU_ALL_DATA';

interface PayloadTypes {
    [SET_MAIN_MENU_VACANCY]: VacancyInfo;
    [SET_MAIN_MENU_LINK]: Link;
    [RESET_MAIN_MENU_FORM_DATA]: null;
    [RESET_MAIN_MENU_ALL_DATA]: null;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setMainMenuVacancy = ActionCreator(SET_MAIN_MENU_VACANCY);
export const setMainMenuLink = ActionCreator(SET_MAIN_MENU_LINK);
export const resetMainMenuFormData = ActionCreator(RESET_MAIN_MENU_FORM_DATA);
export const resetMainMenuAllData = ActionCreator(RESET_MAIN_MENU_ALL_DATA);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface MainMenuState {
    vacancyId: VacancyId;
    vacancyName: VacancyName;
    link: Link;
}

const MAIN_MENU_INITIAL_STATE = {
    vacancyId: null,
    vacancyName: null,
    link: null,
};

export default createReducer<MainMenuState, PayloadTypes>(MAIN_MENU_INITIAL_STATE, {
    [SET_MAIN_MENU_VACANCY]: (state, { payload }) => ({
        ...state,
        vacancyId: payload.vacancyId,
        vacancyName: payload.vacancyName || null,
    }),
    [SET_MAIN_MENU_LINK]: (state, { payload }) => ({
        ...state,
        link: payload,
    }),
    [RESET_MAIN_MENU_FORM_DATA]: (state) => ({
        ...state,
        vacancyId: null,
        vacancyName: null,
        link: null,
    }),
    [RESET_MAIN_MENU_ALL_DATA]: (state) => ({
        ...state,
        ...MAIN_MENU_INITIAL_STATE,
    }),
});
// ----------------------- /reducer --------------------------------------

// ----------------------- selectors -------------------------------------
export const selectIsMainMenuDataExist = (state: DefaultRootState): boolean =>
    !!state.mainMenu.vacancyId || !!state.mainMenu.link;
export const selectMainMenuVacancyId = (state: DefaultRootState): VacancyId => state.mainMenu.vacancyId;
export const selectMainMenuVacancyName = (state: DefaultRootState): VacancyName => state.mainMenu.vacancyName;
export const selectMainMenuLink = (state: DefaultRootState): Link => state.mainMenu.link;
// ----------------------- /selectors -------------------------------------
